import React from "react";
// Lucide Icons
import {
  BookOpen,
  Lightbulb,
  Sparkles,
  Rabbit,
  Turtle,
  Handshake,
  CornerDownRight,
  Zap,
  Star,
} from "lucide-react";

// Image Imports (Keep these as you had them)
import fox from "../../Photos/grapes.png";
import lion from "../../Photos/lionmouse.png";
import ant from "../../Photos/Antsandgrass.png";
import rabbit from "../../Photos/rabbit.png";
import sticks from "../../Photos/sticks.png";


import fox_p1 from "../../Photos/Stories/Fox/fox1.png";
import fox_p2 from "../../Photos/Stories/Fox/fox2.png"; 
import fox_p3 from "../../Photos/Stories/Fox/fox3.png";
import fox_p4 from "../../Photos/Stories/Fox/fox4.png";

// Lion and the Mouse (Story 2)
import lion_p1 from "../../Photos/Stories/Lion/lion1.png"; 
import lion_p2 from "../../Photos/Stories/Lion/lion2.png"; 
import lion_p3 from "../../Photos/Stories/Lion/lion3.png"; 
import lion_p4 from "../../Photos/Stories/Lion/lion4.png"; 
import lion_p5 from "../../Photos/Stories/Lion/lion5.png";
import lion_p6 from "../../Photos/Stories/Lion/lion6.png"; 

// Ant and the Grasshopper (Story 3)
import ant_p1 from "../../Photos/Stories/Ants/Ants1.png";
import ant_p2 from "../../Photos/Stories/Ants/Ants2.png";
import ant_p3 from "../../Photos/Stories/Ants/Ants3.png"; 
import ant_p4 from "../../Photos/Stories/Ants/Ants4.png"; 
import ant_p5 from "../../Photos/Stories/Ants/Ants5.png"; 

// Tortoise and the Hare (Story 4)
import rabbit_p1 from "../../Photos/Stories/Rabbit/rabbit1.png"; 
import rabbit_p2 from "../../Photos/Stories/Rabbit/rabbit2.png"; 
import rabbit_p3 from "../../Photos/Stories/Rabbit/rabbit3.png"; 
import rabbit_p4 from "../../Photos/Stories/Rabbit/rabbit4.png"; 
import rabbit_p5 from "../../Photos/Stories/Rabbit/rabbit5.png"; 

// Bundle of Sticks (Story 5)
import sticks_p1 from "../../Photos/Stories/Sticks/stick1.png"; 
import sticks_p2 from "../../Photos/Stories/Sticks/stick2.png"; 
import sticks_p3 from "../../Photos/Stories/Sticks/stick3.png"; 
import sticks_p4 from "../../Photos/Stories/Sticks/stick4.png"; 
import sticks_p5 from "../../Photos/Stories/Sticks/stick5.png"; 
import sticks_p6 from "../../Photos/Stories/Sticks/stick6.png"; 


export const MoralStoriesData = [
  {
    id: 1,
    title: "🦊 The Fox and the Grapes",
    icon: <CornerDownRight className="w-6 h-6 text-pink-600" />,
    img: fox,
    summary:
      "A clever fox tried to reach a bunch of juicy grapes, but when he failed, he pretended they were sour.",
    moral: "Don't say something is bad just because you can't have it.",
    fullStory:
      "A Fox saw some grapes hanging from a vine and wished to eat them. He jumped and leaped with all his might, but the grapes were too high to reach. Finally, the Fox stopped trying, turned up his nose, and said, 'I didn't want those anyway! They are sour and not fit to eat.' He walked away with his nose in the air.",
  },
  {
    id: 2,
    title: "🦁 The Lion and the Mouse",
    icon: <Handshake className="w-6 h-6 text-blue-600" />,
    img: lion,
    summary:
      "A tiny mouse promises to help a mighty lion one day. Later, he frees the lion from a hunter’s net.",
    moral: "No act of kindness is ever too small.",
    fullStory:
      "A Lion was asleep when a little Mouse started running up and down his mane. This woke the Lion, who angrily grabbed the Mouse and prepared to eat him. 'Please, King of the Jungle!' cried the Mouse. 'Forgive me this time! I promise, I will repay you!' The Lion laughed at the idea of a Mouse helping a Lion, but let him go. Later, the Lion was caught in a hunter's strong net. The Mouse, hearing the Lion's roar, ran to the net and quickly chewed the ropes, setting the mighty Lion free. ",
  },
  {
    id: 3,
    title: "🐜 The Ant and the Grasshopper",
    icon: <Sparkles className="w-6 h-6 text-purple-600" />,
    img: ant,
    summary:
      "The hardworking Ant stored food for winter while the Grasshopper only sang. Winter came, and the Grasshopper had nothing to eat.",
    moral: "Hard work and preparation keep you safe in the future.",
    fullStory:
      "All summer long, an Ant worked diligently, storing food for the coming winter. A Grasshopper spent his days singing and laughing at the Ant. 'Why do you work so hard?' the Grasshopper asked. 'Enjoy the sunshine!' When winter arrived, the Ant had plenty of food in his warm home. The Grasshopper, cold and starving, went to the Ant's door to beg for a meal, but the Ant turned him away. ",
  },
  {
    id: 4,
    title: "🐢 The Tortoise and the Hare",
    icon: <Turtle className="w-6 h-6 text-green-600" />,
    img: rabbit,
    summary:
      "The fast Hare took a nap during a race, letting the slow but steady Tortoise win.",
    moral: "Slow and steady wins the race.",
    fullStory:
      "A speedy Hare made fun of a slow Tortoise, challenging him to a race. The Tortoise accepted. When the race began, the Hare ran far ahead. Feeling so confident he couldn't lose, the Hare decided to take a short nap. The Tortoise, never stopping and walking slowly but steadily, passed the sleeping Hare and crossed the finish line first.",
  },
  {
    id: 5,
    title: "🌳 The Bundle of Sticks",
    icon: <Rabbit className="w-6 h-6 text-yellow-600" />,
    img: sticks,
    summary:
      "A father showed his sons that sticks are weak alone but strong together.",
    moral: "We are stronger when we stay united.",
    fullStory:
      "A father had many sons who were always fighting and arguing. He gave them a bundle of sticks and asked them to break it. They all tried, but none could break the whole bundle. The father then untied the bundle and asked them to break the sticks one by one. They did this easily. The father said, 'My sons, when you fight, you are like the single sticks—easy to break. But when you are united, you are like the bundle—impossible to break.'",
  },
];





// --- PLACEHOLDER IMAGE IMPORTS ---
// IMPORTANT: Replace these with your actual imported image variables 
// (e.g., import fox_p1 from "../../Photos/fox/p1.png";)

// Fox and the Grapes (Story 1)

// ---------------------------------------------------------------


export const MoralFullStoriesData = [
  // STORY 1: THE FOX AND THE GRAPES (4 Images) - NO CHANGE NEEDED
  {
    id: 1,
    title: "🦊 The Fox and the Grapes",
    icon: <CornerDownRight className="w-6 h-6 text-pink-600" />,
    img: fox, 
    summary: "A clever fox tried to reach a bunch of juicy grapes, but when he failed, he pretended they were sour.",
    moral: "Don't say something is bad just because you can't have it.",
    fullStory: [
      { text: "A Fox saw some grapes hanging from a vine and wished to eat them", img: fox_p1 },
      { text: "He jumped and leaped with all his might, but the grapes were too high to reach", img: fox_p2 },
      { text: "Finally, the Fox stopped trying, turned up his nose, and said, 'I didn't want those anyway! They are sour and not fit to eat.'", img: fox_p3 },
      { text: "He walked away with his nose in the air", img: fox_p4 },
    ],
  },

  // STORY 2: THE LION AND THE MOUSE (6 Images) - REVERTED TO ORIGINAL STRUCTURE
  {
    id: 2,
    title: "🦁 The Lion and the Mouse",
    icon: <Handshake className="w-6 h-6 text-blue-600" />,
    img: lion,
    summary: "A tiny mouse promises to help a mighty lion one day. Later, he frees the lion from a hunter’s net.",
    moral: "No act of kindness is ever too small.",
    fullStory: [
      { text: "A Lion was asleep when a little Mouse started running up and down his mane", img: lion_p1 },
      { text: "This woke the Lion, who angrily grabbed the Mouse and prepared to eat him", img: lion_p2 },
      { text: " 'Please, King of the Jungle!' cried the Mouse. 'Forgive me this time! I promise, I will repay you!'", img: lion_p3 },
      { text: "The Lion laughed at the idea of a Mouse helping a Lion, but let him go", img: lion_p4 },
      { text: "Later, the Lion was caught in a hunter's strong net", img: lion_p5 },
      { text: "The Mouse, hearing the Lion's roar, ran to the net and quickly chewed the ropes, setting the mighty Lion free", img: lion_p6 },
    ],
  },

  // STORY 3: THE ANT AND THE GRASSHOPPER (5 Images) - MATCHES ORIGINAL STRUCTURE
  {
    id: 3,
    title: "🐜 The Ant and the Grasshopper",
    icon: <Sparkles className="w-6 h-6 text-purple-600" />,
    img: ant,
    summary: "The hardworking Ant stored food for winter while the Grasshopper only sang. Winter came, and the Grasshopper had nothing to eat.",
    moral: "Hard work and preparation keep you safe in the future.",
    fullStory: [
      { text: "All summer long, an Ant worked diligently, storing food for the coming winter", img: ant_p1 },
      { text: "A Grasshopper spent his days singing and laughing at the Ant", img: ant_p2 },
      { text: " 'Why do you work so hard?' the Grasshopper asked. 'Enjoy the sunshine!'", img: ant_p3 },
      { text: "When winter arrived, the Ant had plenty of food in his warm home", img: ant_p4 },
      { text: "The Grasshopper, cold and starving, went to the Ant's door to beg for a meal, but the Ant turned him away", img: ant_p5 },
    ],
  },

  // STORY 4: THE TORTOISE AND THE HARE (5 Images) - MATCHES ORIGINAL STRUCTURE
  {
    id: 4,
    title: "🐢 The Tortoise and the Hare",
    icon: <Turtle className="w-6 h-6 text-green-600" />,
    img: rabbit,
    summary: "The fast Hare took a nap during a race, letting the slow but steady Tortoise win.",
    moral: "Slow and steady wins the race.",
    fullStory: [
      { text: "A speedy Hare made fun of a slow Tortoise, challenging him to a race, the Tortoise accepted.", img: rabbit_p1 },
      { text: "When the race began, the Hare ran far ahead", img: rabbit_p2 },
      { text: "Feeling so confident he couldn't lose, the Hare decided to take a short nap", img: rabbit_p3 },
      { text: "The Tortoise, never stopping and walking slowly but steadily, passed the sleeping Hare", img: rabbit_p4 },
      { text: " and crossed the finish line first", img: rabbit_p5 },
    ],
  },

  // STORY 5: THE BUNDLE OF STICKS (6 Images) - EXPANDED TO 6 STEPS
  {
    id: 5,
    title: "🌳 The Bundle of Sticks",
    icon: <Rabbit className="w-6 h-6 text-yellow-600" />,
    img: sticks,
    summary: "A father showed his sons that sticks are weak alone but strong together.",
    moral: "We are stronger when we stay united.",
    fullStory: [
      { text: "A father had many sons who were always fighting and arguing", img: sticks_p1 },
      { text: "He gave them a bundle of sticks and asked them to break it", img: sticks_p2 },
      { text: "They all tried, but none could break the whole bundle", img: sticks_p3 },
      { text: "The father then untied the bundle and asked them to break the sticks one by one", img: sticks_p5 },
      { text: "The sons easily broke the sticks individually", img: sticks_p4 }, // New step for better flow
      { text: "The father said, 'My sons, when you fight, you are like the single sticks—easy to break. But when you are united, you are like the bundle—impossible to break.'", img: sticks_p6 }, // Updated to p6
    ],
  },
];

